import {SemanticCOLORS, SemanticICONS} from "semantic-ui-react";

export interface WorkflowStatusType extends Record<string, any> {
  key: string,
  message: string,
  icon: SemanticICONS,
  color: SemanticCOLORS
}

const WorkflowStatus: Record<string, WorkflowStatusType> = {
  NOT_STARTED: {key: 'NOT_STARTED', message: 'workflow.status.not.started', icon: 'minus', color: 'grey'},
  IN_PROGRESS: {key: 'IN_PROGRESS', message: 'workflow.status.in.progress', icon: 'ellipsis horizontal', color: 'grey'},
  FINISHED_SUCCESS: {key: 'FINISHED_SUCCESS', message: 'workflow.status.finished.success', icon: 'check', color: 'green'},
  FINISHED_WARNING: {key: 'FINISHED_WARNING', message: 'workflow.status.finished.warning', icon: 'warning', color: 'orange'},
  FINISHED_FAILURE: {key: 'FINISHED_FAILURE', message: 'workflow.status.finished.failure', icon: 'close', color: 'red'},
  FINISHED_UNKNOWN: {key: 'FINISHED_UNKNOWN', message: 'workflow.status.finished.unknown', icon: 'question', color: 'grey'},
}
export default WorkflowStatus;